<div *ngIf="hasProfile" class="ind-btn-close-wrapper">
  <button (click)="onRemoveInput(idx)" class="ind-btn-close">
    <img [src]="'assets/icons/i-close.svg'" alt="Buttons" />
  </button>
</div>

<div class="serial-wrapper">
  <div class="serial-container">
    <div class="serial-number-control serial-wrapper__serial-number-control">
      <app-custom-input-text
        label="captive.form.my-device.serialNumber"
        placeholder="captive.form.my-device.serialNumber"
        key="serial"
        type="text"
        [isValid]="isValidSerial"
        [control]="serialControl"
        [submitted]="isSubmittedSerialControl"
        [errorsList]="errorFeedbackList.serial"
        [isRequired]="true"
        (changedValue)="onChangedSerial($event)" />

      <div class="info-wrapper">
        <div class="info-icon" (click)="onOpenSerialInfo()"></div>
      </div>
    </div>

    <div class="shared-device-section">
      <app-shared-device-control
        class="shared-device-control"
        [hintText]="'captive.form.my-device.shared-device.hint.adding-shared-device'"
        [submitted]="isSubmittedPassphraseControl"
        [errorsList]="errorFeedbackList.passphrase"
        [passphraseControl]="passphraseControl"
        (useSharedDeviceChanged)="onUseSharedDevice($event)"
        (openSharedDeviceInfo)="onOpenSharedDeviceInfo()"
        (changedPassphraseValue)="onChangedPassphrase($event)" />
    </div>

    <app-problem-with-serial-error *ngIf="isShowProblemFormFor()" />
  </div>
  <!-- NOTE: Do not remove, helps update form status -->
  <ng-template *ngIf="serialControl.statusChanges | async" />
</div>
